export default {
    userInfo: {}
}
